import { aabb2Height } from "./aabb2Types";
import { WindingDir } from "./core";
import {
  polyLine2AABB2,
  polyLine2Area,
  polyLine2Close,
  polyLine2CloseWithInfo,
  polyLine2Copy,
  polyLine2CopySimplify,
  polyLine2Reverse,
  polyLine2ReverseCopy,
  polyLine2SetCCW,
  polyLine2SetCW,
  polyLine2WindingDir,
} from "./polyLine2";
import type { PolyLine2Polygon } from "./polyLine2Types";

export function polygonReverse(pg: PolyLine2Polygon): PolyLine2Polygon {
  pg.forEach((p) => polyLine2Reverse(p));
  return pg;
}

export function polygonReverseCopy(pg: PolyLine2Polygon): PolyLine2Polygon {
  return pg.map((p) => polyLine2ReverseCopy(p));
}

export function polygonArea(pg: PolyLine2Polygon) {
  let area = polyLine2Area(pg[0]);
  for (let i = 1; i < pg.length; i++) {
    area -= polyLine2Area(pg[i]);
  }
  return area;
}

export function profileAreaAbs(profile: PolyLine2Polygon): number {
  return Math.abs(polygonArea(profile));
}

export function polygonSetAreaAbs(profiles: PolyLine2Polygon[]): number {
  let area = 0;
  for (const profile of profiles) {
    area += profileAreaAbs(profile);
  }
  return area;
}

export function polygonYLength(pg: PolyLine2Polygon) {
  const outline = pg[0];
  if (!outline) {
    return 0;
  }
  return aabb2Height(polyLine2AABB2(outline));
}

export function polygonCopy(pg: PolyLine2Polygon): PolyLine2Polygon {
  return pg.map((p) => polyLine2Copy(p));
}

export function polygonCopySimplify(pg: PolyLine2Polygon): PolyLine2Polygon {
  return pg.map((p) => polyLine2CopySimplify(p));
}

export function polygonSetCW(pg: PolyLine2Polygon): PolyLine2Polygon {
  pg.forEach((p, i) => (i === 0 ? polyLine2SetCW(p) : polyLine2SetCCW(p)));
  return pg;
}

/**
 *
 * @param pg
 * @returns
 * polygon with outer ring set to CCW and inner rings set to CW and an array of boolean
 * with true if the ring's winding dir was set or false if it was unchanged
 */
export function polygonSetCCW(pg: PolyLine2Polygon): { polygon: PolyLine2Polygon; requiredSet: boolean[] } {
  const set: boolean[] = [];
  for (let i = 0; i < pg.length; i++) {
    const p = pg[i];
    if (i === 0) {
      if (polyLine2WindingDir(p) === WindingDir.CCW) {
        set.push(false);
      } else {
        set.push(true);
        polyLine2SetCCW(p);
      }
      continue;
    }

    if (polyLine2WindingDir(p) === WindingDir.CW) {
      set.push(false);
    } else {
      set.push(true);
      polyLine2SetCW(p);
    }
  }
  return { polygon: pg, requiredSet: set };
}

export function polygonClose(pg: PolyLine2Polygon): { polygon: PolyLine2Polygon; requiredClose: boolean[] } {
  const requiredClosingArr: boolean[] = [];

  for (let i = 0; i < pg.length; i++) {
    const p = pg[i];
    const { requiredClosing } = polyLine2CloseWithInfo(p);
    requiredClosingArr.push(requiredClosing);
  }

  pg.forEach((p) => polyLine2Close(p));
  return { polygon: pg, requiredClose: requiredClosingArr };
}
